import { render, staticRenderFns } from "./otherData.vue?vue&type=template&id=0c7ee775"
import script from "./otherData.vue?vue&type=script&lang=js"
export * from "./otherData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports